import React from 'react'
import { initializeApollo } from '@gql/client'
import {
  PaginaDocument,
  RivenditoriDocument,
  ProvinceDocument,
  RegioniDocument,
  RegioneDocument,
} from '@gql/graphql'
import { NextWrapper } from 'data-fetching-wrapper'
import { RivenditoriTemplate } from '@components/templates'

const RivenditoriPage = ({ pagina, rivenditori, province, localita }) => (
  <RivenditoriTemplate
    pagina={pagina}
    rivenditori={rivenditori}
    items={province}
    localita={localita}
    variant="regione"
  />
)

export const getStaticPaths = NextWrapper.getStaticPaths(async ({ locales }) => {
  let paths = []

  return {
    paths: paths,
    fallback: 'blocking',
  }
}, '/rivenditori/[slug_regione]')

export const getStaticProps = NextWrapper.getStaticProps(
  async ({ params: { slug_regione }, locale, preview, previewData }) => {
    const client = initializeApollo(locale)

    const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}

    const {
      data: { pagina },
    } = await client.query({
      query: PaginaDocument,
      variables: { chiave: 'rivenditori', preview },
      context: {
        headers,
      },
    })

    if (!pagina) {
      return {
        notFound: true,
      }
    }

    const {
      data: { rivenditori },
    } = await client.query({
      query: RivenditoriDocument,
      variables: {
        regione: slug_regione,
      },
    })

    if (!rivenditori || rivenditori.length == 0) {
      return {
        notFound: true,
      }
    }

    const {
      data: { province },
    } = await client.query({
      query: ProvinceDocument,
      variables: {
        regione: slug_regione,
      },
    })

    const {
      data: { regione: localita },
    } = await client.query({
      query: RegioneDocument,
      variables: {
        slug: slug_regione,
      },
    })

    return {
      props: { pagina, rivenditori, province, localita },
      revalidate: 60 * 20,
    }
  },
  '/rivenditori/[slug_regione]'
)

export default RivenditoriPage
